module.exports = __webpack_public_path__ + "static/OklahomaStandard-PrimaryLogo-2f9878ed975a5ceeb408630a11eb7083.svg";